import 'twin.macro';
import { ContactUs } from '@teetsh/app/src/containers/UserSettings/Contact/ContactUs';
import { ShareIdeas } from '@teetsh/app/src/containers/UserSettings/Contact/ShareIdeas';
import React from 'react';
import TwoColumnsCardSidebar from '@teetsh/app/src/components/TwoColumnsCardSidebar';

export function Contact() {
  return (
    <TwoColumnsCardSidebar.Container>
      <ContactUs />
      <ShareIdeas />
    </TwoColumnsCardSidebar.Container>
  );
}

export { Contact as default };
